import InMeeting from './InMeeting';

export default InMeeting;
